import { FC } from "react";
import cn from "classnames";
import { AirLineModel } from "entities/AirSearchCard";
import { resolveDateValues } from "entities/shared/utils";
import { t } from "shared/localization/localization";
import { AirlineRow } from "./AirlineRow";
import styles from "./AirlineList.module.scss";

type AirlineProps = {
  className?: string;
  airline: AirLineModel;
};

export const Airline: FC<AirlineProps> = ({ airline, className }) => {
  const { flightNumber, origin, destination, atd, etd, ata, eta, transportType } = airline;
  const { departureDate, arrivalDate } = resolveDateValues({
    atd,
    etd,
    ata,
    eta,
    formatedDate: true,
    useValuePlaceholder: true,
  });

  return (
    <div className={cn(styles.vessel, className)}>
      <AirlineRow title={t("Flight number")} value={flightNumber} />
      <AirlineRow title={t("Transport type")} value={transportType} />
      <AirlineRow title={t("Origin")} value={origin} />
      <AirlineRow title={t("Destination")} value={destination} />
      <AirlineRow title={departureDate.unit} value={departureDate.value} />
      <AirlineRow title={arrivalDate.unit} value={arrivalDate.value} />
    </div>
  );
};
